<template>
  <div class="ProfileDetails">
    <Loading v-if="loading" />
    <template v-else>
    <h3 class="subTitle">Profile details</h3>
    <div class="profile">
      <div class="left" v-if="isAgencyOwner">
        <div class="details">
          <h4>Advertiser details</h4>
          <w-text-field
            :disabled="isProfileDisabled"
            label="Advertiser name"
            v-model="form.name"
          />
          <TreeSelect
            :disabled="isProfileDisabled"
            class="selectDropDown"
            :placeholder="'Type of Business'"
            @updateValue="updateTypeOfCompany"
            :value="selectedCompanyType"
            :arrData="companyTypeLabels"
            />
          <TreeSelect
            :disabled="isProfileDisabled"
            class="selectDropDown"
            :placeholder="'Industry'"
            @updateValue="updateIndustry"
            :value="selectedIndustry"
            :arrData="industryLabels"
          />
          <TreeSelect
            :disabled="isProfileDisabled"
            class="selectDropDown"
            :placeholder="'Number of employees'"
            @updateValue="updateCompanySize"
            :value="selectedSize"
            :arrData="companySizeLabels"
          />
        </div>
        <div class="address">
          <h4>Advertiser address</h4>
          <TreeSelect
              :disabled="isProfileDisabled"
              class="selectDropDown"
              :placeholder="'Country'"
              @updateValue="updateCountry"
              :value="selectedCountry"
              :arrData="countryLabels"
            />

            <TreeSelect
              :disabled="isProfileDisabled"
              class="selectDropDown"
              :placeholder="'City'"
              @updateValue="updateCity"
              :value="selectedCity"
              :class="{'disabled': !selectedCountry}"
              :arrData="cities[selectedCountry]"
            />

            <w-text-field
              :disabled="isProfileDisabled"
              label="Street address"
              v-model="form.agency.address"
            />

            <w-text-field
              :disabled="isProfileDisabled"
              label="Postal code"
              v-model="form.agency.postal_code"
            />
        </div>
      </div>
      <div class="right">
      <div class="personal">
        <h4 v-if="isAgencyOwner">Personal details</h4>
        <w-text-field
          :disabled="isProfileDisabled"
          label="First name"
          v-model="form.first_name"
        />

        <w-text-field
          :disabled="isProfileDisabled"
          label="Last name"
          v-model="form.last_name"
        />

        <w-text-field
          :disabled="isProfileDisabled"
          label="Phone number"
          v-model="form.phone"
        />
      </div>
      </div>
    </div>
    <div class="submit">
      <w-button :spinner="spinner" type="submit" @click="saveProfile()" class="large"> Save </w-button>
    </div>
    </template>
  </div>
</template>

<script>
  import {
    mapState, mapMutations, mapActions, mapGetters,
  } from 'vuex';
  import cities from '../../../../assets/data/cities.json';
  import Loading from '@/components/Loading.vue';

  export default {
    name: 'ProfileDetails',
    data() {
      return {
        countries: [],
        selectedCountry: null,
        selectedCity: null,
        countryLabels: [],
        cities,
        companyTypes: [],
        companyTypeLabels: [],
        selectedCompanyType: null,
        industryTypes: [],
        industryLabels: [],
        selectedIndustry: null,
        companySizes: [],
        companySizeLabels: [],
        selectedSize: null,
        loading: false,
        spinner: false,
        form: {},
      };
    },
    components: {
      Loading,
    },
    async created() {
      this.loading = true;
      if (!this.profile) {
        await this.doGetProfile();
      }
      this.form = JSON.parse(JSON.stringify({
        ...this.profile,
        agency: this.agency,
      }));
      this.setValues();
      // setTimeout(() => {
      // this.loading = false;
      // }, 2000);
    },
    methods: {
      ...mapActions('Companies', ['doGetProfile']),
      ...mapMutations('Profile', ['setSuccess']),
      ...mapActions('Profile', ['doUpdateProfile']),
      setValues() {
        if (this.config && this.form) {
          this.countries = this.config.countries;
          if (this.agency) {
            const country = this.countries.find(x => x.value === this.form.agency.country);
            if (country) {
              this.selectedCountry = country.label || '';
            }
            this.selectedCity = this.form.agency.city || '';
            this.countryLabels = this.countries.map(x => x.label);
            this.companyTypes = this.config.company_types;
            this.companyTypeLabels = this.companyTypes.map(x => x.label);
            const business = this.companyTypes.find(x => x.value === this.form.agency.company_type);
            if (business) {
              this.selectedCompanyType = business.label || '';
            }
            this.industryTypes = this.config.company_industries;
            this.industryLabels = this.industryTypes.map(x => x.label);
            const industry = this.industryTypes.find(x => x.value === this.form.agency.company_industry);
            if (industry) {
              this.selectedIndustry = industry.label || '';
            }
            this.companySizes = this.config.company_sizes;
            this.companySizeLabels = this.companySizes.map(x => x.label);
            const size = this.companySizes.find(x => x.value === this.form.agency.company_size);
            if (size) {
              this.selectedSize = size.label || '';
            }
          }
        }
        this.loading = false;
      },
      updateTypeOfCompany(val) {
        this.selectedCompanyType = val;
        const business = this.companyTypes.find(x => x.label === this.selectedCompanyType);
        if (business) {
          this.form.agency.company_type = business.value;
        }
      },
      updateIndustry(val) {
        this.selectedIndustry = val;
        const industry = this.industryTypes.find(x => x.label === this.selectedIndustry);
        if (industry) {
          this.form.agency.company_industry = industry.value;
        }
      },
      updateCompanySize(val) {
        this.selectedSize = val;
        const size = this.companySizes.find(x => x.label === this.selectedSize);
        if (size) {
          this.form.agency.company_size = size.value;
        }
      },
      updateCountry(val) {
        this.selectedCountry = val;
        const country = this.countries.find(x => x.label === this.selectedCountry);
        if (country) {
          this.form.agency.country = country.value;
        }
      },
      updateCity(val) {
        this.selectedCity = val;
        this.form.agency.city = val;
      },
      async saveProfile() {
        this.spinner = true;
        try {
          await this.doUpdateProfile(this.form);
          this.setSuccess('Success! Your profile has been updated.');
          this.spinner = false;
        } catch (e) {
          // console.log(e);
        }
      },
    },
    computed: {
      isProfileDisabled() {
        return this.profile && this.profile.account_disabled;
      },
      ...mapState('Companies', ['profile']),
      ...mapGetters('Companies', ['agency', 'isAgencyOwner']),
      ...mapState('Campaigns', ['config']),
    },
    watch: {
      config() {
        this.setValues();
      },
    },
  };
</script>

<style lang="scss">
  @import "../../../../assets/styles/variables";
  @import "../../../../../node_modules/bulma/sass/utilities/mixins";

  .ProfileDetails {
    display: flex;
    flex-direction: column;
    width: 100%;
    h3 {
      margin-bottom: 24px;
    }
    .submit {
      display: flex;
      width: 100%;
      justify-content: flex-end;
      width: 300px;
      align-self: flex-end;
        .button--large {
          width: 100%;
        }
    }
    .profile {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      gap: 20px;
      .details, .address, .personal {
        width: 100%;
      }
      .left {
        display: flex;
        flex-direction: column;
        gap: 20px;
      }
      .left, .right {
        flex: 1;
        .text-field,
        .selectDropDown {
          width: 100%;
        }
      }
      h4 {
        font-family: 'Roboto';
        font-weight: bold;
        font-size: 14px;
        line-height: 16px;
        color: #1A1A1D;
      }
    }
    @include until($tablet) {
      .profile {
        flex-direction: column;
      }
    }
    @media(max-width: 575px) {
      .submit {
        width: 100%;
        margin-top: 20px;
      }
    }
  }
</style>
